export default __webpack_public_path__ + "static/452-636493dca358f4ee4f68da249455f214.gif";